import { ILessonBooking, LessonBooking } from 'app/constants/schemas/LessonBooking';
import { ILessonStudent, LessonStudent } from 'app/constants/schemas/LessonStudent';
import { ILessonTeacher, LessonTeacher } from 'app/constants/schemas/LessonTeacher';
import { BoundedPeriod, BoundedPeriodMarshaller } from 'app/constants/schemas/Period';
import vmClient from 'app/services/vmClient';
import { Entity, EntityStringId, IEntity, IEntityType } from 'app/types/entity';

export interface ICombinedLessonBooking extends IEntity {
  attributes: {
    id: EntityStringId;
    time: BoundedPeriod;
  };
  associations: {
    bookings: ILessonBooking[];
    student: ILessonStudent;
    teacher: ILessonTeacher;
  };
}

export type CombinedLessonBooking = Entity<ICombinedLessonBooking>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CombinedLessonBooking: IEntityType<ICombinedLessonBooking> = vmClient.defineClass({
  typeName: 'CombinedLessonBooking',
  version:  1,
  persisted: true,

  attributes: {
    time: {
      type:       BoundedPeriod,
      notNull:    true,
      marshaller: BoundedPeriodMarshaller,
    },
    slotTimeRanges: {
      type: BoundedPeriod,
      marshaller: BoundedPeriodMarshaller,
      notNull: true,
      collection: true,
    },
  },

  associations: {
    bookings: {
      type: LessonBooking,
      collection: true,
      notNull: true,
      shared: true,
    },
    student: {
      type:   LessonStudent,
      shared: true,
      notNull: true,
    },
    teacher: {
      type:   LessonTeacher,
      shared: true,
      notNull: true,
    },
  },
});
